var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready
    ? _c(
        "div",
        { staticClass: "carousel relative" },
        [
          _c(
            "tiny-slider",
            {
              ref: "slider",
              attrs: {
                dots: true,
                loop: true,
                swipeAngle: 30,
                lazyload: false,
                "controls-container": "#customcontrols_" + _vm._uid,
                rewind: false,
                "auto-width": false,
                autoplay: _vm.autoplay,
                "fixed-width": false,
                nav: true,
                responsive: _vm.responsive
              }
            },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "controls",
              attrs: { id: "customcontrols_" + _vm._uid }
            },
            [
              _c("div", { ref: "prev", staticClass: "left" }),
              _vm._v(" "),
              _c("div", { ref: "next", staticClass: "right" })
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }